import axios from 'axios';
import React, { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';
import { unitsDataInterface } from '../../../components/locations/locationDetail/LocationDetail';
import {
    GET_UNITS_FAILURE,
    GET_UNITS_REQUEST,
    GET_UNITS_SUCCESS,
    DELETE_UNITS_FAILURE,
    DELETE_UNITS_REQUEST,
    DELETE_UNITS_SUCCESS,
} from '../constants/units.constants';
import { getUnitById } from './unitById.action';
import { getUnitsByLocationId } from './unitsByLocationId';

interface unitDetails {
    name?: string;
    baths?: number;
    image_url?: string;
    price?: number;
    rooms?: number;
    size?: number;
    status?: boolean;
    location: string;
    nickName?: string;
    unitOccupancyStatus?: string;
    unitLeasedStatus?: string;
    deleteImage_url?: string;
    description?: string | null;
    buildingName: string | null;
}

// Get Units
const getUnitsRequest = () => {
    return {
        type: GET_UNITS_REQUEST,
    };
};

const getUnitsSuccess = (unitsData: AnyIfEmpty<object>) => {
    return {
        type: GET_UNITS_SUCCESS,
        payload: unitsData,
    };
};

const getUnitsFailure = (unitsError: string) => {
    return {
        type: GET_UNITS_FAILURE,
        payload: unitsError,
    };
};

// Delete Units
const deleteUnitsRequest = () => {
    return {
        type: DELETE_UNITS_REQUEST,
    };
};

const deleteUnitsSuccess = (unitsData: AnyIfEmpty<object>) => {
    return {
        type: DELETE_UNITS_SUCCESS,
        payload: unitsData,
    };
};

const deleteUnitsFailure = (unitsError: string) => {
    return {
        type: DELETE_UNITS_FAILURE,
        payload: unitsError,
    };
};

// Get Units Dispatch
export const getUnits = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getUnitsRequest());
        return axios
            .get(`/admin/units`)
            .then((response) => dispatch(getUnitsSuccess(response.data.data)))
            .catch((error) => dispatch(getUnitsFailure(error)));
    };
};

export const uploadImages = async (imageFiles: File[]) => {
    const image_url: string[] = [];
    const formData = new FormData();
    imageFiles.map((file: File) => formData.append('file', file));
    const imageData = await axios.post(`/admin/upload/file?folderName=unit`, formData);
    if (imageData?.data?.length > 0) {
        imageData.data.map((image: { location: string }) => image_url.push(image.location));
    }
    return image_url;
};

// Add Units Dispatch
export const addUnits = (
    unitDetails: unitDetails,
    setUnitsData: React.Dispatch<React.SetStateAction<unitsDataInterface[]>>,
    setCurrentPage: React.Dispatch<React.SetStateAction<number>> | undefined,
    onSuccess?: (message: string) => void, onFailure?: (message: string) => void
) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        axios
            .post(`/admin/units`, unitDetails)
            .then(async (response) => {
                if (response.data.statusCode === 201) {
                    dispatch(getUnitsByLocationId(unitDetails.location, 1, undefined, undefined, undefined, undefined, setUnitsData));
                    setCurrentPage?.(1);
                    onSuccess && onSuccess(response.data.message)
                    // window.location.reload();
                } else {
                    onFailure && onFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                onFailure && onFailure(error.message);
            });

    };
};

// Edit Units Dispatch
export const editUnits = (id: string, unitDetails: unitDetails, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        return axios
            .put(`/admin/units/${id}`, unitDetails)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getUnits());
                    dispatch(getUnitById(id));
                    onSuccess && onSuccess(response.data.message)
                }
                else {
                    onFailure && onFailure(response.data.message);
                }
            })
            .catch((error) => {
                onFailure && onFailure(error.message);
            });
    };
};

// Delete Staff
export const deleteUnits = (id: string, locationId: string, reason: string, locId: string, navigate?: NavigateFunction) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(deleteUnitsRequest());
        await axios
            .delete(`/admin/units/${id}`, {
                data: {
                    reason: reason,
                }
            })
            .then((response) => {
                dispatch(getUnitsByLocationId(locationId, 1));
                dispatch(deleteUnitsSuccess(response.data));
                navigate?.(`/location/${locId}`, { replace: true });
            })
            .catch((error) => dispatch(deleteUnitsFailure(error)));
    };
};

export const uploadProfileImage = async (imageFiles: File, folderName: string) => {
    const formData = new FormData();
    formData.append('file', imageFiles);
    const imageData = await axios.post(`/admin/upload/file?folderName=${folderName}`, formData);
    if (imageData?.data?.length) {
        return imageData?.data[0]?.location;
    }
    return;
};

interface UnitStatusPayload {
    unitOccupancyStatus?: 'Vacant' | 'Occupied';
    unitLeasedStatus?: 'Available' | 'NotAvailable';
    unitRentReady?: 'true' | 'false';
}

export const updateUnitStatus = (
    id: string,
    payload: UnitStatusPayload,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void
) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        return axios
            .put(`/admin/units/status/${id}`, payload)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    // 🔄 refresh list & detail
                    dispatch(getUnits());
                    dispatch(getUnitById(id));
                    onSuccess && onSuccess(response.data.message);
                } else {
                    onFailure && onFailure(response.data.message);
                }
            })
            .catch((error) => {
                onFailure && onFailure(error?.message || 'Something went wrong');
            });
    };
};
